import React, { PropsWithChildren } from 'react'
import BigImageBanner from '../../components/BigImageBanner'
import { IMAGE_FILTER } from '../../utils/detectWebPSupported'
import classes from './bigImage.module.scss'


type BigImageProps = {
  image: {
    filename: string
  }
  image_position: 'left' | 'right' | 'center'
}


export const BigImage: React.FC<PropsWithChildren<{slice: BigImageProps}>> = ({ slice })=> {
  const { image, image_position } = slice

  return (
    <div className={classes.bigImageContainer}>
      <BigImageBanner imageUrl={`${image.filename}${IMAGE_FILTER}`} imagePosition={image_position} />
    </div>
  )
}


export default BigImage
